import { createFileRoute } from '@tanstack/react-router';
import { HolidaysPage } from '@/features/calendar/holidays-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/hr/holidays')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/holidays');
  },
  component: HolidaysPage,
});
